import { isFile } from 'customer-data-objects/property/PropertyIdentifier';
import { useIsTieredPricingProperty } from './useIsTieredPricingProperty';
import { useObjectTypeId } from './useObjectTypeId';
import { useProperty } from './useProperty';
export const useHideFloatingEditIcon = () => {
  const property = useProperty();
  const objectTypeId = useObjectTypeId();
  const isTieredPricingProperty = useIsTieredPricingProperty({
    objectTypeId,
    property
  });
  return isFile(property) || isTieredPricingProperty;
};